import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import BlogHero from "@/components/landing/blog/BlogHero";
import BlogGrid from "@/components/landing/blog/BlogGrid";
import { SEOHead } from "@/hooks/useSEO";
import { useLanguage } from "@/hooks/useLanguage";
import {
  StructuredDataHead,
  LLMMetadataHead,
  organizationSchema,
  createWebPageSchema,
} from "@/hooks/useStructuredData";

const Blog = () => {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen bg-background">
      <SEOHead page="blog" locale={language} />
      <StructuredDataHead schemas={[
        organizationSchema,
        createWebPageSchema(
          "Blog – AI Agents, WhatsApp Business & Automatisierung | Chathero",
          "Bleiben Sie auf dem Laufenden über AI Agents, WhatsApp Business und Automatisierung. Tipps, Anleitungen und Erfolgsgeschichten.",
          "/blog",
          [
            { name: "Home", url: "/" },
            { name: "Blog", url: "/blog" },
          ]
        ),
        {
          "@context": "https://schema.org",
          "@type": "Blog",
          name: "Chathero Blog",
          description: "Insights zu AI Agents, Automatisierung und Kundenkommunikation",
          url: "https://chathero.ai/blog",
          publisher: organizationSchema,
          inLanguage: language === "en" ? "en-US" : "de-DE",
        },
      ]} />
      <LLMMetadataHead
        title="Blog – AI Agents, WhatsApp Business & Automatisierung | Chathero"
        description="Bleiben Sie auf dem Laufenden über AI Agents, WhatsApp Business und Automatisierung. Tipps, Anleitungen und Erfolgsgeschichten für intelligentes Messaging."
        keywords="AI Agent Blog, WhatsApp Business, Chatbot Automatisierung, Kundenservice KI, Marketing Automatisierung"
        canonicalUrl="https://chathero.ai/blog"
        aiCategory="Blog, Wissenscenter, AI Insights"
        aiEntityType="Blog"
        aiUseCase="Fachartikel zu AI Agents, WhatsApp Marketing, Kundenservice-Automatisierung"
      />
      <Header />
      <main>
        <BlogHero />
        <BlogGrid />
      </main>
      <Footer />
    </div>
  );
};

export default Blog;
